import { render, staticRenderFns } from "./StepSparring.vue?vue&type=template&id=45314087&scoped=true"
import script from "./StepSparring.vue?vue&type=script&lang=js"
export * from "./StepSparring.vue?vue&type=script&lang=js"
import style0 from "./StepSparring.vue?vue&type=style&index=0&id=45314087&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45314087",
  null
  
)

export default component.exports